import Vue from 'vue';
import Router from 'vue-router';
import Signin from '@/pages/Signin';
import SelectEntity from '@/pages/SelectEntity';
import SetPassword from '@/pages/SetPassword';
import SetSignInMethod from '@/pages/SetSignInMethod';
import ResetPassword from '@/pages/ResetPassword';
import TheTemplate from '@/pages/registration/TheTemplate';
import Payment from '@/pages/Payment';
import UpdatePayment from '@/pages/UpdatePayment';
import ClientDashboard from '@/pages/ClientDashboard';
import ClientHelpCenter from '@/pages/ClientHelpCenter';
import Settings from '@/pages/Settings';
import Questionnaire from '@/pages/Questionnaire';
import DocumentDropOff from '@/pages/DocumentDropOff';
import CheckoutCompleted from '@/pages/CheckoutCompleted';
import SignatureRequest from '@/pages/SignatureRequest';
import ReviewSignatureRequest from '@/pages/signature-request/ReviewSignatureRequest';
import TaxReturnDelivery from '@/pages/tax-return-delivery/TaxReturnDelivery';
import TaxReturnDeliveryAdminView from '@/pages/tax-return-delivery/TaxReturnDeliveryAdminView';
import K1Package from '@/pages/tax-return-delivery/K1Package';
import ProcessPayment from '@/pages/tax-return-delivery/ProcessPayment';
import EmbeddableDocumentsPage from '@/pages/EmbeddableDocumentsPage';
import DocumentsPage from '@/pages/DocumentsPage';
import ReviewAndExportPage from '@/pages/ReviewAndExportPage';
import ProductGuide from '@/pages/ProductGuide';
import CreateQuestionnaireFromTemplate from '@/pages/CreateQuestionnaireFromTemplate';
// ADMIN PAGES
import AdminDashboard from '@/pages/admin/AdminDashboard';
import TimesheetPage from '@/pages/admin/TimesheetPage';
import TaskBoard from '@/pages/accountant/TaskBoard';
import Reports from '@/pages/admin/Reports';
import SuggestedTasks from '@/pages/accountant/SuggestedTasks';
import TodoTasks from '@/pages/accountant/TodoTasks';
// ACCOUNTANT
import Profile from '@/pages/accountant/Profile';
// import DocumentsSearch from '@/pages/accountant/DocumentsSearch';
import MyCloud from '@/pages/accountant/MyCloud';
import FirmSettings from '@/pages/accountant/FirmSettings';
import MyReminders from '@/pages/accountant/MyReminders';
import ActivitySummary from '@/pages/accountant/ActivitySummary';
import Overview from '@/pages/accountant/Overview';
import QuestionnaireTemplates from '@/pages/accountant/QuestionnaireTemplates';
import Conversation from '@/pages/accountant/Conversation';
import Conversations from '@/pages/accountant/Conversations';
// LANDING PAGE RESOURCES
import ElectronicSignature from '@/pages/resources/ElectronicSignature';
import CreateFirm from '@/pages/resources/CreateFirm';
// SORABAN ONLY PAGES
import PosthogReplay from '@/pages/posthog/PosthogReplay';
import FilingInstructions from '@/pages/tax-return-delivery/FilingInstructions';
import VariableHelpers from '@/pages/VariableHelpers';

const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;

Vue.use(Router);

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (
      err.name !== 'NavigationDuplicated' &&
      err.message &&
      err.message.indexOf('navigation guard') === -1
    )
      throw err;
  });
};

Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (
      err.name !== 'NavigationDuplicated' &&
      err.message &&
      err.message.indexOf('navigation guard') === -1
    )
      throw err;
  });
};

const router = new Router({
  routes: [
    {
      path: '/onboarding',
      redirect: '/questionnaire',
    },
    {
      path: '/signin',
      name: 'signin',
      component: Signin,
      meta: {
        topNavigationDisabled: true,
      },
    },
    {
      path: '/document-drop-off',
      name: 'documentDropOff',
      component: DocumentDropOff,
      meta: {
        topNavigationDisabled: true,
        requiresAuth: false,
      },
    },
    {
      path: '/set-password',
      name: 'SetPassword',
      component: SetPassword,
      meta: {
        requiresAuth: true,
        sideNavigationOff: true,
      },
    },
    {
      path: '/set-sign-in-method',
      name: 'SetSignInMethod',
      component: SetSignInMethod,
      meta: {
        requiresAuth: true,
        sideNavigationOff: true,
      },
    },
    {
      path: '/select-entity',
      name: 'SelectEntity',
      component: SelectEntity,
      meta: {
        requiresAuth: true,
        sideNavigationOff: true,
      },
    },
    {
      path: '/embed',
      name: 'embed',
      component: EmbeddableDocumentsPage,
      meta: {
        embeddable: true,
      },
    },
    {
      path: '/template/:id',
      name: 'template',
      component: TheTemplate,
    },
    {
      path: '/payment',
      name: 'payment',
      component: Payment,
      meta: {
        requiresAuth: true,
        hideFeedback: true,
      },
    },
    {
      path: '/electronic-signature-policy',
      name: 'ElectronicSignature',
      component: ElectronicSignature,
    },
    {
      path: '/create-firm',
      name: 'CreateFirm',
      component: CreateFirm,
    },
    {
      path: '/create-questionnaire-from-template',
      name: 'CreateQuestionnaireFromTemplate',
      component: CreateQuestionnaireFromTemplate,
    },
    {
      path: '/update-payment',
      name: 'update-payment',
      component: UpdatePayment,
      props: true,
      meta: {
        requiresAuth: true,
        hideFeedback: true,
      },
    },
    {
      path: '/dashboard/:hash?',
      name: 'new-dashboard',
      component: ClientDashboard,
      meta: {
        tab: 'dashboard',
        newDashboard: true,
        sideNavigationOff: true,
        requiresAuth: true,
      },
    },
    {
      path: '/inbox/:hash?',
      name: 'inbox',
      component: ClientDashboard,
      meta: {
        tab: 'inbox',
        newDashboard: true,
        sideNavigationOff: true,
        requiresAuth: true,
      },
    },
    {
      path: '/documents/:hash?',
      name: 'client-documents',
      component: ClientDashboard,
      meta: {
        tab: 'documents',
        newDashboard: true,
        sideNavigationOff: true,
        requiresAuth: true,
      },
    },
    {
      path: '/profile/:hash?',
      name: 'client-profile',
      component: ClientDashboard,
      meta: {
        tab: 'profile',
        newDashboard: true,
        sideNavigationOff: true,
        requiresAuth: true,
      },
    },
    {
      path: '/product-guide',
      name: 'product-guide',
      component: ProductGuide,
      meta: {
        requiresAuth: true,
        advisor: true,
        sideNavigationOff: true,
      },
    },
    {
      path: '/help',
      name: 'help',
      component: ClientHelpCenter,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/questionnaire/:hash?',
      name: 'questionnaire',
      component: Questionnaire,
      meta: {
        requiresAuth: true,
        sideNavigationOff: true,
      },
    },
    {
      path: '/checkout-completed',
      name: 'checkout-completed',
      component: CheckoutCompleted,
    },
    {
      path: '/signature-request/:hash?',
      name: 'signature-request',
      component: SignatureRequest,
      meta: {
        requiresAuth: true,
        sideNavigationOff: true,
        layoutPaddingDisabled: true,
        disableFooter: true,
        topNavigationDisabled: true,
      },
    },
    {
      path: '/review-signature-request/:id',
      name: 'review-signature-request',
      component: ReviewSignatureRequest,
      meta: {
        requiresAuth: true,
        disableFooter: true,
        sideNavigationOff: true,
        topNavigationDisabled: true,
        layoutPaddingDisabled: true,
      },
    },
    {
      path: '/tax-return-delivery-admin-view/:id',
      name: 'tax-return-delivery-admin-view',
      component: TaxReturnDeliveryAdminView,
      meta: {
        requiresAuth: true,
        disableFooter: true,
        sideNavigationOff: true,
        topNavigationDisabled: true,
        layoutPaddingDisabled: true,
      },
    },
    {
      path: '/tax-return-delivery/:id',
      name: 'tax-return-delivery',
      component: TaxReturnDelivery,
      meta: {
        requiresAuth: true,
        disableFooter: true,
        sideNavigationOff: true,
        topNavigationDisabled: true,
        layoutPaddingDisabled: true,
      },
    },
    {
      path: '/tax-return-delivery/:id/process-payment',
      name: 'process-payment',
      component: ProcessPayment,
      meta: {
        requiresAuth: true,
        disableFooter: true,
        sideNavigationOff: true,
        topNavigationDisabled: true,
        layoutPaddingDisabled: true,
      },
    },
    {
      path: '/k1-package',
      name: 'k1-package',
      component: K1Package,
      meta: {
        requiresAuth: false,
        disableFooter: true,
        sideNavigationOff: true,
        topNavigationDisabled: true,
        layoutPaddingDisabled: true,
      },
    },
    {
      path: '/admin-dashboard/:hash?',
      name: 'admin-dashboard',
      component: AdminDashboard,
      meta: {
        requiresAuth: true,
        advisor: true,
      },
    },
    {
      path: '/admin/:hash?',
      name: 'admin',
      component: AdminDashboard,
      meta: {
        requiresAuth: true,
        advisor: true,
      },
    },
    {
      path: '/admin-profile',
      name: 'profile',
      component: Profile,
      meta: {
        requiresAuth: true,
        advisor: true,
        sideNavigationOff: true,
      },
    },
    {
      path: '/task-board',
      name: 'task-board',
      component: TaskBoard,
      meta: {
        requiresAuth: true,
        advisor: true,
        sideNavigationOff: true,
      },
    },
    {
      path: '/suggested-tasks',
      name: 'suggested-tasks',
      component: SuggestedTasks,
      meta: {
        requiresAuth: true,
        advisor: true,
        sideNavigationOff: true,
      },
    },
    {
      path: '/todo-tasks',
      name: 'todo-tasks',
      component: TodoTasks,
      meta: {
        requiresAuth: true,
        advisor: true,
        sideNavigationOff: true,
      },
    },
    {
      path: '/cloud',
      name: 'cloud',
      component: MyCloud,
      meta: {
        requiresAuth: true,
        advisor: true,
        sideNavigationOff: true,
      },
    },
    {
      path: '/firm-settings',
      name: 'firm-settings',
      alias: '/firm-settings/stripe-oauth',
      component: FirmSettings,
      meta: {
        requiresAuth: true,
        advisor: true,
        sideNavigationOff: true,
      },
    },
    {
      path: '/reminders',
      name: 'reminders',
      component: MyReminders,
      meta: {
        requiresAuth: true,
        advisor: true,
        sideNavigationOff: true,
      },
    },
    {
      path: '/summary',
      name: 'summary',
      component: ActivitySummary,
      meta: {
        requiresAuth: true,
        advisor: true,
        sideNavigationOff: true,
      },
    },
    {
      path: '/overview',
      name: 'overview',
      component: Overview,
      meta: {
        requiresAuth: true,
        advisor: true,
        sideNavigationOff: true,
      },
    },
    {
      path: '/admin-documents/:hash?',
      name: 'admin-documents',
      component: DocumentsPage,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/review-export/:hash?',
      name: 'review-export',
      component: ReviewAndExportPage,
      meta: {
        requiresAuth: true,
        disableFooter: true,
      },
    },
    {
      path: '/reports',
      name: 'reports',
      component: Reports,
      meta: {
        requiresAuth: true,
        advisor: true,
        desktopOnly: true,
      },
    },
    {
      path: '/questionnaire-templates',
      name: 'onboarding-settigs',
      component: QuestionnaireTemplates,
      meta: {
        advisor: true,
        desktopOnly: true,
        sideNavigationOff: true,
        requiresAuth: true,
      },
    },
    {
      path: '/timesheet',
      name: 'timesheets',
      component: TimesheetPage,
      meta: {
        requiresAuth: true,
        advisor: true,
        sideNavigationOff: true,
      },
    },
    {
      path: '/conversation/:hash?',
      name: 'conversation',
      component: Conversation,
      meta: {
        requiresAuth: true,
        advisor: false,
      },
    },
    {
      path: '/messages/:hash?',
      name: 'messages',
      component: Conversations,
      meta: {
        requiresAuth: true,
        advisor: true,
      },
    },
    {
      path: '/settings/:hash?',
      name: 'settings',
      component: Settings,
      meta: {
        requiresAuth: true,
        // desktopOnly: true,
      },
    },
    {
      path: '/reset-password',
      props: true,
      name: 'reset-password',
      component: ResetPassword,
      meta: {
        requiresAuth: false,
        advisor: false,
        topNavigationDisabled: true,
      },
    },
    {
      path: '/posthog-replay',
      name: 'PosthogReplay',
      component: PosthogReplay,
      meta: {
        requiresAuth: true,
        hideSelectEntity: true,
        sideNavigationOff: true,
        layoutPaddingDisabled: true,
        disableFooter: true,
      },
    },
    {
      path: '/filing-instructions',
      name: 'FilingInstructions',
      component: FilingInstructions,
      meta: {
        requiresAuth: true,
        disableFooter: true,
        sideNavigationOff: true,
        topNavigationDisabled: true,
        layoutPaddingDisabled: true,
      },
    },
    {
      path: '/variable-helpers',
      name: 'variable-helpers',
      component: VariableHelpers,
      meta: {
        advisor: true,
        desktopOnly: true,
        sideNavigationOff: true,
        requiresAuth: true,
      },
    },
    {
      path: '/:hash?',
      name: 'dashboard',
      component: ClientDashboard,
      meta: {
        requiresAuth: true,
        sideNavigationOff: true,
        newDashboard: true,
      },
    },
  ],
  mode: 'history',
});

export default router;
